import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/customer-top-ups', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/customer-top-ups', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store }
